// extracted by mini-css-extract-plugin
export default {"spinner_rXNP":"BouncingBall_spinner_rXNP__6rGmH","spinner_YeBj":"BouncingBall_spinner_YeBj__3UiHq"};